module.exports = __webpack_public_path__ + "img/kirinyaga.802f71eb.png";